module.exports = __webpack_public_path__ + "img/liveing_icon.3cdab803.gif";